import React from 'react';
import { Layout } from '../components/common';

const InwardManagementDemo = () => {
  return (
    <Layout activeNav="inward" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Inward Management</h1>
        <p className="text-gray-600">Manage inbound inventory and receipts.</p>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-gray-600 text-lg">Inward Management Content Coming Soon</p>
      </div>
    </Layout>
  );
};

export default InwardManagementDemo;
